import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import NewEntityButton from './NewEntityButton';
import { TableScreenWithoutUpdate } from '../blocks/table_block';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';

const API_ENDPOINT = 'rawhtml/';

export default class RawHtmlScreen extends React.Component {
    constructor(props) {
        super(props);
        this.refreshState = this.refreshState.bind(this);
        this.removeItemHandler = this.removeItemHandler.bind(this);
        this.state = {
            results: [],
            previous: 'none',
            next: 'none',
            total_pages: 0,
            current_page: 1,
        };
        this.API_ENDPOINT_QS = '';
    }

    refreshState() {
        this.setState({ results: [] });
    }

    removeItemHandler(event) {
        if (window.confirm(`Внимание! Вы действительно хотите удалить ${event.currentTarget.dataset.name || ''}?`)) {
            Fetcher(`rawhtml/${event.currentTarget.id}/`, 'DELETE', this.refreshState);
        }
    }

    columns = [{
        Header: 'Код',
        accessor: 'id',
        maxWidth: 200,
        Cell: (row) => (
            <div>
                [raw_html]
                {row.value}
                [/raw_html]
            </div>
        ),
    }, {
        Header: 'HTML',
        accessor: 'html',
    }, {
        Header: '',
        accessor: 'id',
        maxWidth: 50,
        Cell: (row) => (
            <div>
                <Link to={`${PROJECT_PREFIX}/rawhtml/${row.value}/edit`}>
                    <FontAwesomeIcon icon="pencil-alt" />
                </Link>
                <Button size="sm" variant="link" id={row.value} data-name={row.original.id} onClick={this.removeItemHandler}>
                    <FontAwesomeIcon id={row.value} icon="trash" />
                </Button>

            </div>
        ),
    },

    ];

    render() {
        return (
            <div className="container-fluid">
                <Row className="mb-2">
                    <Col md={12}>
                        <NewEntityButton to="/rawhtml/new" />
                    </Col>
                </Row>
                <TableScreenWithoutUpdate
                    columns={this.columns}
                    endpoint={API_ENDPOINT + this.API_ENDPOINT_QS}
                    data={this.state}
                />
            </div>

        );
    }
}
